import { Link } from 'react-router-dom';
import { Button } from '@nimbitlabs/ui';

interface NotFoundProps {
  /**
   * Custom title (default: "404")
   */
  title?: string;
  /**
   * Custom message (default: "Page not found")
   */
  message?: string;
  /**
   * Home link path (default: "/")
   */
  homeLink?: string;
  /**
   * Custom home button text (default: "Go back home")
   */
  homeText?: string;
  /**
   * Additional content to render
   */
  children?: React.ReactNode;
}

export function NotFound({
  title = '404',
  message = 'Page not found',
  homeLink = '/',
  homeText = 'Go back home',
  children,
}: NotFoundProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="mb-4 text-6xl font-bold text-foreground">{title}</h1>
        <p className="mb-6 text-xl text-muted-foreground">{message}</p>
        {children}
        <Button asChild className="mt-6">
          <Link to={homeLink}>{homeText}</Link>
        </Button>
      </div>
    </div>
  );
}

export default NotFound;
